import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { type AppDispatch, type AppState } from "../../src/store/Store";
import { setLoggedUser } from "../../src/components/Authentication/modules/actions";

const mapStateToProps = (state: AppState) => ({
  state: {
    loggedUser: state.user.loggedUser,
  },
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators(
    {
      setLoggedUser,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
